import { useTranslation } from "react-i18next"
import { IoMdCheckmarkCircleOutline } from "react-icons/io"
import { useNavigate } from "react-router"

import { Cell, Row } from "@/components/Table/Table"
import IconOption from "@/components/TableOptions/IconOption"
import type { Survey } from "@/types/surveyTypes"
import { linkIcon } from "@/utils/variables"

export default function SurveysItem({
  ele,
  from,
}: {
  ele: Survey
  from: number
}) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Row key={ele.id} className={"fw-medium"}>
      <Cell>{`${from}`}</Cell>
      <Cell>{ele.title}</Cell>
      <Cell>
        <div>
          <p
            style={{
              width: "400px",
              maxWidth: "500px",
              whiteSpace: "normal", // يخلي النص يلف
              overflowWrap: "break-word", // يكسر الكلمة الطويلة لو مفيش مسافات
            }}
          >
            {(ele?.description?.length || 0) > 150
              ? `${ele?.description?.slice(0, 150)} ...`
              : ele?.description}{" "}
          </p>
        </div>
      </Cell>

      <Cell>
        <IconOption
          tooltip={
            ele?.user_answers
              ? t("surveysPage.item.seeAnswers")
              : t("surveysPage.item.answer")
          }
          icon={
            ele?.user_answers ? (
              <IoMdCheckmarkCircleOutline size={24} color="#2bc99c" />
            ) : (
              <span style={{ color: "#F15824" }}>{linkIcon}</span>
            )
          }
          onClick={() => navigate(`answer/${ele.slug}`)}
        />
      </Cell>
    </Row>
  )
}
